import { Global, css } from '@metrika/ui-kit/emotion';
/* Scss & css entries -- only here so order is always the same */
import './App.styles.scss'; // Carbon initialization
import 'react-grid-layout/css/styles.css'; // Required for react-grid-layout
import 'react-resizable/css/styles.css'; // Required for react-grid-layout
import 'react-toastify/dist/ReactToastify.css'; // Toastify default styling
import '@metrika/elastic-charts/dist/theme_only_light.css'; // Required for elastic-charts

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const globalAppStyle = css`
   /// Need grid option to not add page gutters at large viewports, to also use when nesting grids
   /// @link https://github.com/carbon-design-system/carbon/issues/2792
   @media (min-width: 42rem) {
      .cds--grid--no-gutter {
         padding-left: 1rem;
         padding-right: 1rem;
      }
   }

   /*
  Forces overflow menu ... to be visible all the time.

  This is _not_ the intended behavior according to IBM, but it
  was preferred according to design specs.
  */
   .cds--table-column-menu {
      svg {
         opacity: 1 !important;
      }
      button {
         margin-left: auto;
      }
   }

   .cds--breadcrumb-item {
      display: inline-flex;
   }

   //overrides home
   // Give padding to a button when inside a data table footer.
   .data-table-footer.latest-alerts-footer .cds--btn {
      margin-top: 1rem;
   }

   // navigation overrides
   .cds--side-nav__overlay-active {
      z-index: 1;
   }

   .cds--side-nav ~ .cds--content,
   .cds--side-nav.cds--side-nav--expanded ~ .cds--content {
      margin-left: 0;
   }

   // a carbon update changed this value,
   // causing the table to render improperly
   .cds--table-column-checkbox .cds--checkbox-label {
      padding-left: 1rem;
   }

   //removes unwanted padding from modal
   .cds--modal-content {
      margin-bottom: 1rem;
   }
   .cds--modal-scroll-content > *:last-child {
      padding-bottom: 1rem;
   }

   // fix overflow on side nav
   .cds--side-nav {
      overflow: auto !important;
   }
   .cds--side-nav--ux .cds--side-nav__item {
      //overflow: unset !important;
   }

   .cds--side-nav__submenu[aria-expanded='true'] + .cds--side-nav__menu {
      max-height: unset !important;
      visibility: inherit;
   }
`;
const globalAppStyleV11 = css`
   //v11 fix table row border lighter (on v11 1px --cds-border-subtle-01)
   .cds--data-table td,
   .cds--data-table tbody th {
      border-block-end: 1px solid var(--cds-border-subtle-00, #e0e0e0);
   }

   //v11 less padding on sidnavitem icon and link
   .cds--side-nav__icon:not(.cds--side-nav__submenu-chevron) {
      margin-inline-end: 0.5rem;
   }
   .cds--side-nav__item.cds--side-nav__item--icon a.cds--side-nav__link {
      padding-inline-start: 3.5rem;
   }

   //v11 fix space between side nav items
   .cds--side-nav__link-text {
      width: 100%;
   }

   // fix overflow on side nav - enable scrolling when many dashboards
   .cds--side-nav {
      overflow: auto !important;
   }
   .cds--side-nav--ux .cds--side-nav__item {
      overflow: unset !important;
   }

   .cds--side-nav__submenu[aria-expanded='true'] + .cds--side-nav__menu {
      max-height: unset !important;
      visibility: inherit;
   }
`;

export const GlobalAppStyle = (): JSX.Element => <Global styles={globalAppStyleV11} />;
